
const api = {};
const AWSurl = {};
const client = {};

if (process.env.VUE_APP_MasterDataDomain == null) {
  api.masterDataDomain = 'https://railwdevmasterdata.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.userManagementDomain = 'https://railwdevusermanagement.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.clientMasterDataDomain = 'https://railwdevclientmasterdata.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.vacationManagementDomain = 'https://railwdevvacationmanagement.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.stockManagementDomainNotification = 'https://railwdevordermanagement.digitwebsite.ch';
  api.financeDomain = 'https://railwdevaccountingmanagement.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.stockManagementDomain = 'https://railwdevnotabrillant-ordermanagement.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31';
  api.storeDataDomain = 'https://railwdevstoredata.digitwebsite.ch/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31'
  api.inventoryMenagement = 'https://digitinventorymanagement-spim-fashion-development.up.railway.app/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31'
  api.movementService = 'https://digitmovementservice-spim-fashion-development.up.railway.app/api/v1/683872D8-473F-43F4-8DF5-0550FF753A31'

  api.apiKey = 'tododododo'

  // Development:
  // TenantId: 683872D8-473F-43F4-8DF5-0550FF753A31


  // ClientName: NotaBrillant

  AWSurl.bucketName = 'spim-file-development';
  AWSurl.bucketNameInventoryManagement = 'spim-file-development';
  AWSurl.accessKeyId = 'AKIAZN2PMAGNETQFG34B';
  AWSurl.secretAccessKey = '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';
  AWSurl.region = 'eu-central-1';


  client.clientName = 'NotaBrillant';
  client.stateType = 'High';
  client.clientLogo = 'https://spim-file.s3.amazonaws.com/CRM_ClientsPhoto/DrenushaLogoWhite.png'
  // client.clientLogo = 'https://spim-file.s3.amazonaws.com/CRM_ClientsPhoto/ValdrinSahitiWhiteLogo.png'
  // client.clientLogo = 'https://spim-file.s3.amazonaws.com/CRM_ClientsPhoto/FjollaNilaWhiteLogo.png'

  // INFO
  /*
    stateType = 'Low' is for clients [DrenushaXharra]
    stateType = 'Medium' is for clients []
    stateType = 'High' is for clients [FjollaNila, ValdrinSahiti, WaloneFashionGroup, AnariAtelier]
    Also dashboards are seperated based on the stateType not clientName
  */
} else {
  api.masterDataDomain = process.env.VUE_APP_MasterDataDomain;
  api.userManagementDomain = process.env.VUE_APP_UserManagementDomain;
  api.clientMasterDataDomain = process.env.VUE_APP_ClientMasterDataDomain;
  api.vacationManagementDomain = process.env.VUE_APP_VacationManagementDomain;
  api.stockManagementDomainNotification = process.env.VUE_APP_StockManagementDomainNotification;
  api.financeDomain = process.env.VUE_APP_FinanceDomain;
  api.stockManagementDomain = process.env.VUE_APP_StockManagementDomain;
  api.storeDataDomain = process.env.VUE_APP_StoreDataDomain;
  api.inventoryMenagement = process.env.VUE_APP_InventoryMenagement;
  api.movementService = process.env.VUE_APP_MovementService;

  api.ApiKey = process.env.VUE_APP_ApiKey;

  AWSurl.bucketName = process.env.VUE_APP_BucketName;
  AWSurl.bucketNameInventoryManagement = process.env.VUE_APP_BucketNameInventoryManagement;
  AWSurl.accessKeyId = process.env.VUE_APP_accessKeyId;
  AWSurl.secretAccessKey = process.env.VUE_APP_secretAccessKey;
  AWSurl.region = process.env.VUE_APP_region;

  client.clientName = process.env.VUE_APP_ClientName;
  client.stateType = process.env.VUE_APP_stateType;
  client.clientLogo = process.env.VUE_APP_clientLogo
  client.invoiceLogo = process.env.VUE_APP_invoiceLogo
}

module.exports = {
  api,
  AWSurl,
  client,
};
